module.exports = __webpack_public_path__ + "media/images/top-search-bg@3x-124ee5f9960ee3d696b8ef93823f060e.png";